module.exports = __webpack_public_path__ + "static/media/RequstBanner.7ed4bb38.svg";